import styled from '@emotion/styled'
import { Image, Props as ImageProps } from 'app/components/Common/Image'
import { Rumble } from 'app/components/Icons'
import { Link } from 'gatsby'
import React, { memo } from 'react'

export interface Props {
  className?: string
  image?: ImageProps
  subtitle?: string
  title: string
  URL: string
}

export const Slide = memo(function Slide({
  className,
  image,
  subtitle,
  title,
  URL,
}: Props) {
  if (!title || !URL) {
    return null
  }

  return (
    <Container className={className} to={URL}>
      <Background className="bg">
        {image ? <Image {...image} /> : null}
      </Background>

      <Wrapper>
        <Title>
          <Inner>{title}</Inner>
        </Title>

        {subtitle ? <Subtitle>{subtitle}</Subtitle> : null}

        <Rumble />
      </Wrapper>
    </Container>
  )
})

const Background = styled.div`
  aspect-ratio: 1.33;
  background: ${({ theme }) => theme.colors.variants.neutralLight5};
  overflow: hidden;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
    transition: 0.3s ease-in-out;
  }

  @media (max-width: 1199px) {
    aspect-ratio: 1.66;
  }
`

const Wrapper = styled.div`
  margin-top: 2.5rem;
  transition: 0.3s ease-in-out;

  svg {
    width: 0.375rem;
    height: 0.375rem;
    fill: ${({ theme }) => theme.colors.variants.neutralDark2};
    margin-top: 1.25rem;
  }

  @media (max-width: 1199px) {
    margin-top: 1.25rem;
  }
`

const Title = styled.div`
  color: ${({ theme }) => theme.colors.variants.neutralDark2};
  font-family: ${({ theme }) => theme.fontFamily.heading};
  font-size: 1.5rem;
  line-height: 2rem;
`

const Inner = styled.span`
  padding-bottom: 0.25rem;
  position: relative;
  &:after {
    content: '';
    height: 0.0625rem;
    background: ${({ theme }) => theme.colors.variants.neutralLight2};
    position: absolute;
    right: 100%;
    bottom: 0;
    left: 0;
    transition: 0.4s ease-in-out;
  }
`

const Subtitle = styled.div`
  color: ${({ theme }) => theme.colors.variants.neutralLight1};
  font-family: ${({ theme }) => theme.fontFamily.paragraph};
  font-size: 1rem;
  font-weight: 300;
  line-height: 1.375rem;
  margin-top: 0.75rem;
`

const Container = styled(Link)`
  display: block;
  text-align: left;
  &:hover {
    ${Background} {
      img {
        transform: scale(1.1);
      }
    }
    ${Wrapper} {
      transform: translateY(-0.25rem);
    }
    ${Inner} {
      &:after {
        right: 0;
      }
    }
  }
`
